export const validation = {
  required: "Toto pole je povinné",
  string: "Pole musí obsahovat text",
  number: "'Pole musí obsahovat čislo'",
};
